export default __webpack_public_path__ + "54b7951b4ba27ead274e2962d48723cf.jpg";